export default "__VITE_ASSET__CAO53IUR__"